// extracted by mini-css-extract-plugin
module.exports = {"section":"MatchLearnerPage_section__niupK","eyebrow":"MatchLearnerPage_eyebrow__2KnzF"};